export const sampleHotels = [
  {
    id: 1,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Bali',
    title: 'Bali',
    duration: '18-28 July',
    hotelName: 'Grand Resort and Spa',
    subtitle: 'Grand Resort and Spa',
    rating: 3.7,
    description: 'Flight serviced by Lufthansa airlines',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
  {
    id: 2,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Dubai',
    title: 'Dubai',
    duration: '16-28 July',
    hotelName: 'Gevora Hotel',
    subtitle: 'Grand Resort and Spa',
    rating: 4.75,
    description: 'Flight serviced by Etihad Airways',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
  {
    id: 3,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Bali',
    title: 'Bali',
    duration: '18-28 July',
    hotelName: 'Grand Resort and Spa',
    subtitle: 'Grand Resort and Spa',
    rating: 3.7,
    description: 'Flight serviced by Lufthansa airlines',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
  {
    id: 4,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Bali',
    title: 'Bali',
    duration: '18-28 July',
    hotelName: 'Grand Resort and Spa',
    subtitle: 'Grand Resort and Spa',
    rating: 3.7,
    description: 'Flight serviced by Lufthansa airlines',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
  {
    id: 5,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Bali',
    title: 'Bali',
    duration: '18-28 July',
    hotelName: 'Grand Resort and Spa',
    subtitle: 'Grand Resort and Spa',
    rating: 3.7,
    description: 'Flight serviced by Lufthansa airlines',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
  {
    id: 6,
    image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    isFavorite: false,
    destinationName: 'Bali',
    title: 'Bali',
    duration: '18-28 July',
    hotelName: 'Grand Resort and Spa',
    subtitle: 'Grand Resort and Spa',
    rating: 3.7,
    description: 'Flight serviced by Lufthansa airlines',
    price: {
      currency: 'EUR',
      binding: false,
      net: 100,
      gross: 100,
      exchange: {
        currency: 'EUR',
        rate: 1,
      },
      markups: null,
    },
    type: 'Full package',
  },
];

export const EXPERIENCE_TILE = {
  image: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
  title: 'Surfing',
  subtitle: 'Exploring'
};

export const TRIP_TILE = {
  ways: [{
    arrivalName: 'Name',
    baggage: {
      pieces: 1,
      size: 25,
      type: 'luggage'
    },
    cancellation: {
      charge: '25',
      time: '25'
    },
    classType: 'First',
    companyName: 'BlueAir',
    departureName: 'LEG',
    endDateTime: new Date(),
    logo: 'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    startDateTime: new Date(),
    tripNumber: '21',
    type: 'First'
  }],
  limitedSeats: 2,
  price: 350
};

export const IMAGE_TILE_URL = {
  sample: 'https://i.postimg.cc/kgXHKmQs/image-tile-sample-image.jpg',
  sigiriya: 'https://i.postimg.cc/G3yPztCK/sigiriya.png',
};

export const activities = [{
  label: 'Waterfall Tour',
  url: '#',
  imageSrc: 'https://images.unsplash.com/photo-1476610182048-b716b8518aae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2159&q=80'
}, {
  label: 'Parachute Jump',
  url: '#',
  imageSrc: 'https://images.unsplash.com/photo-1601024445121-e5b82f020549?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHBhcmFjaHV0ZXxlbnwwfHwwfHw%3D&w=1000&q=80'
},
{
  label: 'Spa Day',
  url: '#',
  imageSrc: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80'
}]

export const HERO_IMG_URL = {
  trip_packs: 'https://i.postimg.cc/kD3RRcqX/image-tile-sample-image.jpg',
  stays: 'https://i.postimg.cc/dvS4H77z/BAH-2021-7-min-scaled.jpg',
  tickets: 'https://i.postimg.cc/kD3RRcqX/image-tile-sample-image.jpg',
  wishlist: 'https://i.postimg.cc/kD3RRcqX/image-tile-sample-image.jpg',
};

export const PERIODS = [{
  id: 1,
  start: new Date(),
  end: new Date(),
  price: 756
},{
  id: 2,
  start: new Date(),
  end: new Date(),
  price: 756
},{
  id: 3,
  start: new Date(),
  end: new Date(),
  price: 756
},{
  id: 4,
  start: new Date(),
  end: new Date(),
  price: 756
},{
  id: 5,
  start: new Date(),
  end: new Date(),
  price: 756
}];

export const FAVORITES_DEMO = [
  {
    id: 1,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Madeira',
    type: 'Full package',
    dates: '11-25 Jul',
  },
  {
    id: 2,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Bali',
    type: 'Full package',
    dates: '11-28 Aug',
  },
  {
    id: 3,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Valencia',
    type: 'Stay',
    dates: '18-25 Jul',
  },
  {
    id: 4,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Tulum',
    type: 'Full package',
    dates: '11-29 Jul',
  },
];

export const TRIPS_DEMO = [
  {
    id: 1,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Madeira',
    airplane: 2,
    beds: 2,
    train: 3,
    dates: '11-25 Jul',
  },
  {
    id: 2,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Bali',
    airplane: 2,
    beds: 2,
    train: 3,
    dates: '11-28 Aug',
  },
  {
    id: 3,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Valencia',
    airplane: 2,
    beds: 2,
    train: 3,
    dates: '18-25 Jul',
  },
  {
    id: 4,
    images: [
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
      'https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg',
    ],
    title: 'Tulum',
    airplane: 2,
    beds: 2,
    train: 3,
    dates: '11-29 Jul',
  },
];
